<app-navbar></app-navbar>

<app-modal-pop-up/>

<section class="bg-black pt-20 pb-14">
    <div class="max-w-6xl mx-auto">
        <app-partners-carrousel/>

    </div>
</section>

<div class="w-full bg-black text-white pt-32 min-h-[70dvh]">
    <div class="container mx-auto text-white py-5">
        <div class="text-center border-2 border-[#24e46e] shadowTable p-16 rounded-md w-full md:max-w-6xl mx-auto">
            <h1 class="text-xl md:text-2xl font-bold mb-8 uppercase">{{texts.general_title}}</h1>
            <div class="grid grid-cols-1 xl:grid-cols-1 gap-4 my-6">
                <div class="items-center w-1/2 mx-auto">
                    <label for="categoria" class="text-xl text-white uppercase mb-2">{{texts.category}}:</label>
                    <select [(ngModel)]="category" id="Anchura" name="Anchura" class="border border-gray-300 bg-white text-black 
                    rounded px-3 py-2 w-full focus:outline-none focus:ring-2 focus:ring-emerald-500" (change)="reviewCategory()">
                        <option selected disabled>{{texts.category}}</option>
                        <option value="4">{{texts.products}}</option>
                        <option value="3">{{texts.car_model}}</option>
                        <option value="medida">{{texts.tire_size}}</option>
                    </select>
                </div>
            </div>          

            @if (category == 3 || category == 4) {
                <div>
                    <p class="text-center text-xl uppercase">Productos</p>
                    <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 mt-6 mb-4">
                        @for (item of categoryInfo; track $index) {
                            @if (item.active) {
                                <div class="border-2 border-green-500 overflow-hidden text-white bg-black rounded shadow-sm shadow-green-500 cursor-pointer" (click)="seeDetailPage(item.id,item.link_rewrite)">
                                    <figure class="bg-white">
                                        @if (category == 3) {
                                            <img [src]="item.imageUrl" alt="tire" class="w-full h-52" />
                                        }
                                        @else {
                                            <img [src]="item.imageUrl" alt="tire" class="w-full" />
                                        }

                                        
                                    </figure>
                                    <div class="p-6">
                                        <header>
                                            <h3 class="text-xl font-medium">{{item.name}}</h3>
                                        </header>
                                    </div>
                                </div>
                            }
                            
                        }
                    </div>
                </div>
                
            }

            @if (category == 'medida') {
                <div class="grid grid-cols-1 xl:grid-cols-3 gap-4 mt-6 mb-4">
                    <div class="items-center">
                        <label for="Anchura" class="text-xl text-white uppercase mb-2">{{texts.ancho}}:</label>
                        <select (change)="changeAncho()" [(ngModel)]="ancho" id="Anchura" name="Anchura" class="border border-gray-300 bg-white text-black rounded px-3 py-2 w-full focus:outline-none focus:ring-2 focus:ring-emerald-500">
                            <option selected disabled>{{texts.ancho}}</option>
                            @for (item of ancho_opts; track $index) {
                                <option [ngValue]="item">{{item.name}}</option>
                            }

                        </select>
                    </div>
                    <div class="items-center">
                        <label for="Perfil" class="text-xl text-white uppercase mb-2">{{texts.perfil}}:</label>
                        <select (change)="changePerfil()" [disabled]="readonly_perfil" [(ngModel)]="perfil" id="Perfil" name="Perfil" class="border border-gray-300 bg-white text-black rounded px-3 py-2 w-full focus:outline-none focus:ring-2 focus:ring-emerald-500">
                            <option [value]="undefined" selected disabled>{{texts.perfil}}</option>
                            @for (item of perfil_opts; track $index) {
                                <option [ngValue]="item">{{item.name}}</option>
                            }
                        </select>
                    </div>
                    <div class="items-center">
                        <label for="Diámetro" class="text-xl text-white uppercase mb-2">{{texts.tamano_aro}}:</label>
                        <select [disabled]="readonly_tamano_aro" [(ngModel)]="tamano_aro" id="Diámetro" name="Diámetro" class="border border-gray-300 bg-white text-black rounded px-3 py-2 w-full focus:outline-none focus:ring-2 focus:ring-emerald-500">
                            <option [value]="undefined" selected disabled>{{texts.tamano_aro}}</option>
                            @for (item of tamano_aro_opts; track $index) {
                                <option [ngValue]="item">{{item.name}}</option>
                            }
                        </select>
                    </div>
                    
                    @if (ancho != undefined) {
                        <div class="col-span-1 xl:col-span-2 mt-6">
                            <button (click)="search()" class="cursor-pointer w-full bg-[#24e46e] text-black font-bold py-3 px-4 rounded hover:bg-[#1bbf5a] transition duration-300 focus:outline-none focus:ring-2 focus:ring-emerald-500">
                                {{texts.search_btn}}
                            </button>
                            
                        </div>
                        <div class="col-span-1 xl:col-span-1 mt-6" >
                            <button  (click)="getDataSizes()" class="cursor-pointer w-full bg-red-500 text-black font-bold py-3 px-4 rounded hover:bg-red-700 
                            transition duration-300 focus:outline-none focus:ring-2 focus:ring-emerald-500 items-center flex justify-center">
                                <svg style="width: 25px;" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" stroke="#000000"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <path d="M10 12L14 16M14 12L10 16M4 6H20M16 6L15.7294 5.18807C15.4671 4.40125 15.3359 4.00784 15.0927 3.71698C14.8779 3.46013 14.6021 3.26132 14.2905 3.13878C13.9376 3 13.523 3 12.6936 3H11.3064C10.477 3 10.0624 3 9.70951 3.13878C9.39792 3.26132 9.12208 3.46013 8.90729 3.71698C8.66405 4.00784 8.53292 4.40125 8.27064 5.18807L8 6M18 6V16.2C18 17.8802 18 18.7202 17.673 19.362C17.3854 19.9265 16.9265 20.3854 16.362 20.673C15.7202 21 14.8802 21 13.2 21H10.8C9.11984 21 8.27976 21 7.63803 20.673C7.07354 20.3854 6.6146 19.9265 6.32698 19.362C6 18.7202 6 17.8802 6 16.2V6" stroke="#FFF" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path> </g></svg>
                            </button>
                        </div>
                    }
                    @else {
                        <div class="col-span-1 xl:col-span-3 mt-6">
                            <button (click)="search()" class="cursor-pointer w-full bg-[#24e46e] text-black font-bold py-3 px-4 rounded hover:bg-[#1bbf5a] transition duration-300 focus:outline-none focus:ring-2 focus:ring-emerald-500">
                                {{texts.search_btn}}
                            </button>
                            
                        </div>
                    }
                    
                </div>
            }
            
        </div>


    </div>

    <!-- <div class="container mx-auto text-white mt-8">
        <div class="w-full md:w-3/5 lg:w-3/5 mx-auto">
            <div class="grid grid-cols-1 md:grid-cols-3 gap-2">
            
                <div class="overflow-hidden text-white bg-black rounded shadow-sm shadow-emerald-500">
                    <figure class="bg-white">
                        <img src="/assets/img/tire_search/659e71601ccc97ccc4f898a4_xnex-tireonwheel.webp" alt="card image" class="w-full" />
                    </figure>
                    <div class="p-6">
                        <header>
                        <h3 class="text-xl font-medium">XNEX Tire</h3>
                        <p class="text-base">Lorem ipsum dolor, sit amet consectetur adipisicing elit. Dolorum alias incidunt odit ratione? Unde.</p>
                        </header>
                    </div>
                </div>

                <div class="overflow-hidden text-white bg-black rounded shadow-sm shadow-emerald-500">
                    <figure class="bg-white">
                        <img src="/assets/img/tire_search/659e7b4e096a248e64f88362_xlab-tireonwheel.webp" alt="card image" class="w-full" />
                    </figure>
                    <div class="p-6">
                        <header>
                        <h3 class="text-xl font-medium">XLAB tire</h3>
                        <p class="text-base">Lorem ipsum dolor sit, amet consectetur adipisicing elit. Sint veniam debitis nulla illo.</p>
                        </header>
                    </div>
                </div>

            </div>
        </div>
    </div> -->

    <div class="container mx-auto text-white mt-32">
        <img src="/assets/img/tire_search/65788960b034b2d468caf3ed_Find tire search_Tavola disegno 1.png" class="w-full md:w-2/3 mx-auto" alt="fire tire image" srcset="">
    </div>
</div>


<app-footer></app-footer>